import { useState } from "react";
import { X } from "lucide-react";

export default function CallApplicationModal({ isOpen, onClose, onSubmit }: {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (formData: any) => void;
}) {
    const [form, setForm] = useState({
        promotion_description: "",
        traffic_ownership: "",
        landing_page: "",
        call_volume: "",
        other_rates: "",
    });

    if (!isOpen) return null;

    const handleChange = (field: keyof typeof form, value: string) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSubmit(form);
    };

    return (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
            <div className="bg-white w-full max-w-3xl rounded-2xl shadow-xl p-6 relative overflow-y-auto max-h-[90vh]">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-700"
                >
                    <X size={20} />
                </button>

                <h2 className="text-2xl font-bold text-orange-600 mb-6">
                    Application Form
                </h2>

                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label className="font-semibold block mb-1">
                            Please provide a description for how you plan to promote this offer*
                        </label>
                        <textarea
                            placeholder="Enter text here"
                            className="w-full border rounded p-2 h-28"
                            value={form.promotion_description}
                            onChange={(e) => handleChange("promotion_description", e.target.value)}
                            required
                        />
                    </div>

                    <div>
                        <label className="font-semibold block mb-1">
                            How much of this traffic is owned and operated versus sub-sources?*
                        </label>
                        <p className="text-sm text-gray-600 mt-1">
                            RPM requires all methods of call generation to be submitted for approval...
                        </p>
                        <textarea
                            className="w-full border rounded p-2 h-24 mt-2"
                            value={form.traffic_ownership}
                            onChange={(e) => handleChange("traffic_ownership", e.target.value)}
                            required
                        />
                    </div>

                    <div>
                        <label className="font-semibold block mb-1">
                            Please share the advertorial lander/landing page used to filter or promote this offer:*
                        </label>
                        <input
                            type="text"
                            className="w-full border rounded p-2"
                            value={form.landing_page}
                            onChange={(e) => handleChange("landing_page", e.target.value)}
                            required
                        />
                    </div>

                    <div>
                        <label className="font-semibold block mb-1">
                            Available Call Volume at Current Offer Rate Per Day*
                        </label>
                        <input
                            type="text"
                            className="w-full border rounded p-2"
                            value={form.call_volume}
                            onChange={(e) => handleChange("call_volume", e.target.value)}
                            required
                        />
                    </div>

                    <div>
                        <label className="font-semibold block mb-1">
                            If you have additional call volume available at different rates, please provide details (optional)
                        </label>
                        <textarea
                            className="w-full border rounded p-2 h-24"
                            value={form.other_rates}
                            onChange={(e) => handleChange("other_rates", e.target.value)}
                        />
                    </div>

                    <div className="flex justify-end gap-3 pt-4 border-t">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 rounded bg-orange-500 hover:bg-orange-600 text-white font-semibold"
                        >
                            Apply
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
